import { render, staticRenderFns } from "./djp.vue?vue&type=template&id=ac348bba&scoped=true"
import script from "./djp.vue?vue&type=script&lang=js"
export * from "./djp.vue?vue&type=script&lang=js"
import style0 from "./djp.vue?vue&type=style&index=0&id=ac348bba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac348bba",
  null
  
)

export default component.exports